<template>
  <component :is="currentForm" @toStep2="toStep2" @toStep3="toStep3" />
</template>

<script setup lang="ts">
import { computed, h, ref } from 'vue';
import { checkEmailRegisteredApi, sendRegisterCodeApi } from '~/api/auth';
import Step1 from '~/pages/signup/_components/Step1.vue';
import Step2 from '~/pages/signup/_components/Step2.vue';
import Step3 from '~/pages/signup/_components/Step3.vue';

const Step = {
  Step1: 1,
  Step2: 2,
  Step3: 3,
};

const localePath = useLocalePath();
const query = useRoute().query;
const inviteCode = query.invite_code as string;
const email = query.email as string;
const step = ref(email ? Step.Step2 : Step.Step1);
const nextStep = () => step.value++;
const prevStep = () => step.value--;

const currentForm = computed(() => {
  switch (step.value) {
    case Step.Step1:
      return Step1;
    case Step.Step2:
      return () => h(Step2, { email: form.value.email });
    case Step.Step3:
      return () => h(Step3, { email: form.value.email, code: form.value.code });
  }
});

const form = ref({
  email: '',
  code: '',
  name: '',
  password: '',
  invitationCode: '',
});

const toStep2 = (email: string) => {
  step.value = Step.Step2;
  form.value.email = email;
};

const toStep3 = (code: string) => {
  step.value = Step.Step3;
  form.value.code = code;
};

onMounted(async () => {
  if (inviteCode && email) {
    const isRegistered = await checkEmailRegisteredApi(email);
    if (isRegistered) {
      navigateTo(localePath('/login'));
      return;
    }
    form.value.invitationCode = inviteCode;
    form.value.email = email;
    step.value = Step.Step2;
    sendRegisterCodeApi(form.value.email);
  }
});
</script>